import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import get from 'lodash/get';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import LatestBadge from './LatestBadge.jsx';
import LevelProgress from './LevelProgress.jsx';
import UserAvatar from './UserAvatar.jsx';
import CertificateDownload from './CertificateDownload.jsx';

import { env, lang } from '../../config';

const UserProfile = () => {
  const [res, req] = useHttpStatus();
  const [answerRes, answerReq] = useHttpStatus();

  const [show, setShow] = useState(false);
  const [selectedSex, setSelectedSex] = useState(null);

  useEffect(() => {
    req({ url: '/api/core/users/self' });
    answerReq({ url: '/api/quiz/answers/finished-count' });
  }, []);

  return (
    <PageHttp res={[res, answerRes]}>
      {([user, answers]) => {
        const level = [...env.levels]
          .reverse()
          .find((l) => user.score >= l.score);

        return (
          <>
            <div
              className="mx-3 mt-5 p-5"
              style={{ border: '10px solid #FFEDD7', borderRadius: '85px' }}
            >
              <div className="row">
                <div className="col-lg-12 col-xl my-3 ">
                  <div className="d-flex flex-column align-items-center flex-lg-row align-items-lg-start">
                    <div className="col-auto pr-0 mb-3 mb-lg-0" style={{ width: '214px' }}>
                      <div
                        className="position-relative d-block"
                        onClick={() => setShow(true)}
                      >
                        <UserAvatar active={true} sex={user.sex} />
                        <img
                          src="/assets/img/edit.svg"
                          className="pos-abs-br"
                          style={{ width: '47px', height: '47px' }}
                        />
                      </div>
                    </div>
                    <div className="flex-grow-1 pl-lg-3 text-center text-lg-left">
                      <img src="/assets/img/profile_word.svg" />

                                            <div className="mt-3">
                        <div className="row">
                          {[
                            { k: '姓名', v: lang(user.name?.full) },
                            {
                              k: '級別',
                              v: lang(env.grades[get(user, 'schoolClass.grade')]),
                            },
                            { k: '班別', v: get(user, 'schoolClass.title') },
                            { k: '學校', v: lang(get(user, 'school.title')) },
                            { k: '學號', v: user.studentId },
                            { k: '登入名稱', v: user.email },
                          ]
                            .filter(({ v }) => v)
                            .map(({ k, v }) => (
                              <div key={k} className="col-12 col-lg-6 mb-2">
                                <div className="row no-gutters justify-content-center justify-content-lg-start">
                                  <div
                                    className="col-auto pr-1"
                                    style={{ color: '#5C5C5C' }}
                                  >
                                    {k}：
                                  </div>
                                  <div
                                    className="col text-break"
                                    style={{ color: '#D46000' }}
                                  >
                                    {v}
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-xl my-3">
                  {/* Pass answers as object (period1, period2, period3, ...) */}
                  <LatestBadge answers={answers} />
                </div>
              </div>
            </div>
            {show && (
              <Modal
                show={show}
                onHide={() => setShow(false)}
                centered
                size="lg"
                className="grade-select-modal"
                closeButton={false}
              >
                <div className="modal-header border-0 pb-0">
                  <div className="d-flex justify-content-center w-100">
                    <h4
                      style={{
                        color: '#844700',
                        fontSize: '32px',
                        fontWeight: 700,
                      }}
                    >
                      更改頭像
                    </h4>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShow(false)}
                  >
                    <img
                      src="/assets/img/closeBtn.svg"
                      style={{ height: 39 }}
                    />
                  </button>
                </div>
                <div className="modal-body p-2 p-md-4">
                  <div className="row g-2 g-md-4">
                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                      <div
                        className="h-100 rounded-4"
                        style={{
                          backgroundColor: 'white',
                          backgroundImage:
                            selectedSex === 'male'
                              ? 'url(/assets/img/sexBorder-selected.svg)'
                              : 'url(/assets/img/sexBorder.svg)',
                          backgroundRepeat: 'no-repeat',
                          backgroundSize: 'contain',
                          backgroundPosition: 'center',
                          minHeight: '200px',
                          display: 'flex',
                          flexDirection: 'column',
                          padding: '15px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                        onClick={() => setSelectedSex('male')}
                      >
                        <img src="/assets/img/male_sex.svg" alt="male" />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div
                        className="h-100 rounded-4"
                        style={{
                          backgroundColor: 'white',
                          backgroundImage:
                            selectedSex === 'female'
                              ? 'url(/assets/img/sexBorder-selected.svg)'
                              : 'url(/assets/img/sexBorder.svg)',
                          backgroundRepeat: 'no-repeat',
                          backgroundSize: 'contain',
                          backgroundPosition: 'center',
                          minHeight: '200px',
                          display: 'flex',
                          flexDirection: 'column',
                          padding: '15px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                        onClick={() => setSelectedSex('female')}
                      >
                        <img src="/assets/img/female_sex.svg" alt="female" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center mt-4" style={{ gap: '16px' }}>
                    <img
                      src="/assets/img/confirm.svg"
                      alt="confirm"
                      style={{ cursor: 'pointer', opacity: selectedSex ? 1 : 0.5 }}
                      onClick={async () => {
                        if (selectedSex) {
                          try {
                            await req({
                              url: '/api/core/users/self',
                              method: 'patch',
                              data: { sex: selectedSex },
                            });
                            setShow(false);
                            setSelectedSex(null);
                            req({ url: '/api/core/users/self' });
                            window.dispatchEvent(new Event('userUpdated'));
                          } catch (error) {
                            // Handle error if needed
                          }
                        }
                      }}
                    />
                    <img
                      src="/assets/img/cancel.svg"
                      alt="cancel"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setShow(false);
                        setSelectedSex(null);
                      }}
                    />
                  </div>
                </div>
              </Modal>
            )}
          </>
        );
      }}
    </PageHttp>
  );
};

export default UserProfile;
